import ErrorText from './error-text';
export default ErrorText;
